import { reactForceAllUpdate } from '../../component-react';
import { PromptConfirm } from '../confirm';
export const archiveNotes = (rs, noteIDs) => {
    const lbl = noteIDs.length == 1 ? 'this note' : `${noteIDs.length} notes`;
    PromptConfirm({
        size: [300, 190],
        msg: `Are you sure you want to archive ${lbl}?`,
        yes: callback => {
            rs.props.archiving?.onArchive(noteIDs, response => {
                if (response === true) {
                    reactForceAllUpdate();
                    callback(true);
                }
                else {
                    callback(response);
                }
            });
        },
    });
};
export const deleteNotes = (rs, noteIDs) => {
    const lbl = noteIDs.length == 1 ? 'this note' : `${noteIDs.length} notes`;
    PromptConfirm({
        size: [300, 190],
        msg: rs.props.deleting?.retainCopy
            ? `Are you sure you want to mark ${lbl} as deleted?`
            : `Are you sure you want to permanently delete ${lbl}?`,
        yes: callback => {
            rs.props.deleting?.onDelete(noteIDs, response => {
                if (response === true) {
                    reactForceAllUpdate();
                    callback(true);
                }
                else {
                    callback(response);
                }
            });
        },
    });
};
//# sourceMappingURL=delete.js.map